import { map } from 'rxjs/operators';
import { Result } from './class/result.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  private domain = environment.url;
  private sosemDomain = environment.url_sosem;

  constructor(private http: HttpClient) { }

  listar_provincia(){
    const url = `${this.domain}/personal/listar_provincia`;
    const headers = new HttpHeaders().
            set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<Result>(url, {headers: headers}).pipe(map(data => data));
  }

  listar_distrito(id_provincia: number){
    const url = `${this.domain}/personal/listar_distrito/${id_provincia}`;
    const headers = new HttpHeaders().
            set('Content-Type', 'application/json; charset=utf-8');
    return this.http.get<Result>(url, {headers: headers}).pipe(map(data => data));
  }

  listarPersonaSelect(nombres: string){
    const url = `${this.domain}/personal/listar/personas/select/two`;
    const body = JSON.stringify({
      nombres: nombres
    });
    const headers = new HttpHeaders().
            set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<Result>(url,body, {headers: headers}).pipe(map(data => data));
  }

  getUsuarioPersonal(uid: string){
    const url = `${this.domain}/personal/get_usuario`;
    const body = JSON.stringify({
      uid: uid
    });
    const headers = new HttpHeaders().
            set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post<Result>(url,body, {headers: headers}).pipe(map(data => data));
  }

  getUsuarioSosem(uid: string) {
	  const url = `${this.sosemDomain}/api/master/authorizacion/`;
	  const body = JSON.stringify({
		  uid: uid
	  });
	  const headers = new HttpHeaders().
	  set('Content-Type', 'application/json; charset=utf-8');
	  return this.http.post<any>(url,body, {headers: headers}).pipe(map(data => data));
  }

}
